export default "__VITE_ASSET__DqXaAr2e__"